import type { SVGProps } from 'react';

/**
 * "Knowledge Base" open-book brand mark.
 *
 * Mimics the API of @blocksuite/icons/rc icons (e.g. Logo1Icon): it accepts and
 * spreads standard SVG props (className, width, height, fontSize, style,
 * onClick, etc.) and defaults to a 1em square that inherits the surrounding
 * text color via `fill="currentColor"`.
 */
export const KbLogoIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      viewBox="0 0 48 48"
      width="1em"
      height="1em"
      fill="currentColor"
      {...props}
    >
      <path d="M23 15.6c-3.9-2.7-9.9-2.8-13.7-1.3-.8.3-1.3 1-1.3 1.8v16.1c0 1 1 1.7 2 1.4 3.4-1.1 8.4-1 11.6 1.1.9.6 1.4-.1 1.4-.7V15.6z" />
      <path d="M25 15.6c3.9-2.7 9.9-2.8 13.7-1.3.8.3 1.3 1 1.3 1.8v16.1c0 1-1 1.7-2 1.4-3.4-1.1-8.4-1-11.6 1.1-.9.6-1.4-.1-1.4-.7V15.6z" />
    </svg>
  );
};
